import React, { ReactNode } from 'react';

import { GrafanaTheme2 } from '@grafana/data';
import { Icon, useStyles2 } from '@grafana/ui';

import { css } from '@emotion/css';

export interface HighlightProps {
  title: string;
  children?: ReactNode;
  learnMoreLink?: string;
  learnMoreText?: string;
}

export const Highlight = ({ title, children, learnMoreLink, learnMoreText = 'Learn more' }: HighlightProps) => {
  const styles = useStyles2(getStyles);

  return (
    <div className={styles.highlight}>
      <div className={styles.highlightInfo}>
        {title}
        {learnMoreLink && (
          <a className={styles.highlightLink} href={learnMoreLink} target="_blank" rel="noopener noreferrer">
            {learnMoreText} <Icon name="external-link-alt" />
          </a>
        )}
      </div>
      {children && <div className={styles.highlightContent}>{children}</div>}
    </div>
  );
};

const getStyles = (theme: GrafanaTheme2) => {
  return {
    highlight: css`
      display: flex;
      flex-direction: row;
      border-radius: ${theme.shape.radius.default};
      margin-bottom: ${theme.spacing(2)};
      width: 100%;
    `,
    highlightInfo: css`
      display: flex;
      flex-direction: column;
      font-weight: bold;
      background-color: ${theme.colors.background.secondary};
      min-width: 220px;
      padding: 24px;
      margin-right: 12px;
      gap: 12px;
    `,
    highlightLink: css`
      font-size: ${theme.typography.bodySmall.fontSize};
      color: ${theme.colors.text.link};
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    `,
    highlightContent: css`
      margin-top: ${theme.spacing(2)};
    `,
  };
};
